import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import Link from 'atomic/link/link';
import Icon from 'atomic/icon/icon';
import type { BreadcrumbsItemInterface } from 'interfaces/breadcrumbs.interface';

import './breadcrumbs.scss';

const Breadcrumbs: React.FC = (): ReactElement => {
    const items: BreadcrumbsItemInterface[] = useSelector((state: { breadcrumbs: BreadcrumbsItemInterface[]; }) => state.breadcrumbs);
    const elements = items.map(item => (
        <li className="breadcrumbs__item" key={item.id}>
            <Icon icon="chevron-right" className="breadcrumbs__icon breadcrumbs__icon-arrow" />
            {
                item.url
                    ? (
                        <Link href={item.url} className="breadcrumbs__link">
                            {item.name}
                        </Link>
                    )
                    : (
                        <span>
                            {item.name}
                        </span>
                    )
            }
        </li>
    ));

    return (
        <div className="container">
            <ul className="breadcrumbs">
                <li className="breadcrumbs__item">
                    <Link href="/">
                        <Icon icon="home" className="breadcrumbs__icon breadcrumbs__icon-home" />
                    </Link>
                </li>
                {elements}
            </ul>
        </div>
    );
};

export default Breadcrumbs;
